var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-card',{staticClass:"mt-2"},[_c('v-data-table',{attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.items,"sort-by":'code',"hideDefaultFooter":"","disablePagination":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }